import { Outlet } from "react-router-dom";
import { Sidebar } from "./Sidebar";
import { TopBar } from "./TopBar";
import { brand } from "@/theme";

export function AppShell() {
  return (
    <div
      style={{
        display: "flex",
        minHeight: "100vh",
        background: brand.bg,
      }}
    >
      <Sidebar />
      <div style={{ flex: 1, display: "flex", flexDirection: "column", minWidth: 0 }}>
        <TopBar />
        <main
          style={{
            flex: 1,
            padding: "24px 28px 48px",
            maxWidth: 1320,
            width: "100%",
            margin: "0 auto",
            minWidth: 0,
          }}
        >
          <Outlet />
        </main>
      </div>
    </div>
  );
}
